import type { EmergencyOnAzure } from '../../../generated-client/models/EmergencyOnAzure';

export type EmergencyParams = Omit<EmergencyOnAzure, 'emergency_numbers'> & {
  emergency_numbers?: EmergencyOnAzure['emergency_numbers'] | null;
};

/**
 * Represents an emergency created by a user.
 */
export class Emergency implements EmergencyOnAzure {
  public creation_timestamp: EmergencyOnAzure['creation_timestamp'];
  public creator_auth_id: EmergencyOnAzure['creator_auth_id'];
  public creator_first_name: EmergencyOnAzure['creator_first_name'];
  public creator_last_name: EmergencyOnAzure['creator_last_name'];
  public creator_phone_number: EmergencyOnAzure['creator_phone_number'];
  public emergency_id: EmergencyOnAzure['emergency_id'];
  public emergency_numbers?: EmergencyOnAzure['emergency_numbers'];
  public group_name: EmergencyOnAzure['group_name'];
  public group_id: EmergencyOnAzure['group_id'];
  public emergency_email_contacts: EmergencyOnAzure['emergency_email_contacts'];
  public id: EmergencyOnAzure['id'];
  public incident: EmergencyOnAzure['incident'];
  public object_type: EmergencyOnAzure['object_type'];
  public org_code: EmergencyOnAzure['org_code'];
  public resolved_timestamp?: EmergencyOnAzure['resolved_timestamp'];
  public unique_key: EmergencyOnAzure['unique_key'];
  public users: EmergencyOnAzure['users'];
  public _etag: EmergencyOnAzure['_etag'];
  public _ts: EmergencyOnAzure['_ts'];

  constructor({
    creation_timestamp,
    creator_auth_id,
    creator_first_name,
    creator_last_name,
    creator_phone_number,
    emergency_id,
    emergency_numbers = undefined,
    group_name,
    group_id,
    emergency_email_contacts = [],
    id,
    incident,
    object_type,
    org_code,
    resolved_timestamp = null,
    unique_key,
    users,
    _etag = '',
    _ts = 0,
  }: EmergencyParams) {
    this.creation_timestamp = creation_timestamp;
    this.creator_auth_id = creator_auth_id;
    this.creator_first_name = creator_first_name;
    this.creator_last_name = creator_last_name;
    this.creator_phone_number = creator_phone_number;
    this.emergency_id = emergency_id;
    this.emergency_numbers = emergency_numbers ?? undefined;
    this.group_name = group_name;
    this.group_id = group_id;
    this.emergency_email_contacts = emergency_email_contacts;
    this.id = id;
    this.group_id = group_id;
    this.emergency_email_contacts = emergency_email_contacts;
    this.incident = incident;
    this.object_type = object_type;
    this.org_code = org_code;
    this.resolved_timestamp = resolved_timestamp ?? null;
    this.unique_key = unique_key;
    this.users = users;
    this._etag = _etag;
    this._ts = _ts;
  }

  /**
   * Returns whether the emergency is still active (not resolved and created within the last 24 hours).
   */
  public isActiveEmergency(): boolean {
    const timestamp24HoursAgo = Date.now() - 24 * 60 * 60 * 1000;
    const isResolved =
      this.resolved_timestamp !== null && this.resolved_timestamp !== undefined;
    return !isResolved && this.creation_timestamp >= timestamp24HoursAgo;
  }
}
